import { Icon, IconProps } from './Icon';

export const SmartToolsSeatTrackerIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      d="M18.3496 14.6504V20.3496H15.6504V17.3496H8.34961V20.3496H5.65039V14.6504H18.3496ZM9 3.65039H15C15.358 3.65039 15.7019 3.79175 15.9551 4.04492C16.2083 4.2981 16.3496 4.64196 16.3496 5V12.3496H7.65039V5C7.65039 4.64196 7.79175 4.2981 8.04492 4.04492C8.2981 3.79175 8.64196 3.65039 9 3.65039Z"
      stroke="#222B3A"
      strokeWidth="1.3"
      fill="none"
    />
    <path
      d="M5.45472 12.7305C5.80618 12.7305 6.09109 12.4378 6.09109 12.0767C6.09109 11.7156 5.80618 11.4229 5.45472 11.4229C5.10327 11.4229 4.81836 11.7156 4.81836 12.0767C4.81836 12.4378 5.10327 12.7305 5.45472 12.7305Z"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M18.6364 12.7305C18.9878 12.7305 19.2727 12.4378 19.2727 12.0767C19.2727 11.7156 18.9878 11.4229 18.6364 11.4229C18.2849 11.4229 18 11.7156 18 12.0767C18 12.4378 18.2849 12.7305 18.6364 12.7305Z"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M5.45472 12.7305C5.80618 12.7305 6.09109 12.4378 6.09109 12.0767C6.09109 11.7156 5.80618 11.4229 5.45472 11.4229C5.10327 11.4229 4.81836 11.7156 4.81836 12.0767C4.81836 12.4378 5.10327 12.7305 5.45472 12.7305Z"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
